module.exports = __webpack_public_path__ + "static/AH-mx-24edd0063bc478580de64cd6b1fb49ee.webp";